import MaterialReactTable from "material-react-table";
import { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import CssClass from "../../Styles/common.module.css";
import * as common from "../../common/common";

/**
* Table Component

* 1. enableTopToolbar : boolean (default true)
* 2. enableColumnFilters : boolean (default false)
* 3. enableRowSelection : boolean (default false)
* 4. enableRowNumbers : boolean (default true)
* @public
*/

const Table = (props) => {
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [rowSelectionState, setRowSelectionState] = useState({});
  const [rowSelection, setRowSelection] = useState({});
  const columns = props.columns === undefined ? [] : props.columns;

  const enableColumnFilters =
    props.enableColumnFilters === undefined ? false : props.enableColumnFilters;
  const enableRowSelection =
    props.enableRowSelection === undefined ? false : props.enableRowSelection;
  const enableRowNumbers =
    props.enableRowNumbers === undefined ? true : props.enableRowSelection;
  const enableTopToolbar =
    props.enableTopToolbar === undefined ? true : props.enableTopToolbar;
  const selectionDisabled =
    props.selectionDisabled === undefined ? false : props.selectionDisabled;
  const enableStickyHeader =
    props.enableStickyHeader === undefined ? false : props.enableStickyHeader;

  const height =
    props.height === undefined && props.maxHeight === undefined
      ? "570px"
      : props.maxHeight || props.height;
  const width =
    props.width === undefined && props.maxWidth === undefined
      ? "92vw"
      : props.width || props.maxWidth;

  useEffect(() => {
    if (props.data !== undefined) {
      setTableData(props.data);
      setRowSelectionState({});
      setSelectedData([]);
    }
  }, [props.data]);

  useEffect(() => {
    if (
      props.getSelectedData !== undefined &&
      typeof props.getSelectedData === "function"
    ) {
      props.getSelectedData(rowSelection);
    }
  }, [rowSelection]);

  function renderData(cell) {
    try {
      if (
        cell.getValue() === undefined ||
        cell.getValue() === null ||
        cell.getValue() === "" ||
        cell.getValue() === "0001-01-01T00:00:00"
      ) {
        cell.renderValue = () => (
          <>
            <label className={CssClass.tableLabel}> - </label>
          </>
        );
      } else {
        const val = common.c_Dis_DateTime(cell.getValue()).dis;
        if (val !== "-" && typeof val !== "object") {
          cell.renderValue = () => (
            <>
              <label className={CssClass.tableLabel}> {val} </label>
            </>
          );
        }
      }
    } catch (err) {
      const errorMessage = "";
    }
  }

  function checkboxChange(row) {
    // setRowSelectionState(row);
    // console.log(neyyyyyyyyyyyyyyyyyywState);
    // console.log(event);
    // console.log(rowSelectionState);
    // var newState = {
    //   ...rowSelectionState,
    //   [row.id]: event.target.checked,
    // };
    // var newSelectedData = [...selectedData];
    // console.log(row);
    // console.log(newState);
    // console.log(event);
    // if (event.target.checked === true) {
    //   newSelectedData.push(row.id);
    // } else {
    //   newSelectedData = newSelectedData.filter((d) => d !== row.id);
    // }
    // // console.log(newState);
    // // console.log(newSelectedData);
    // if (
    //   props.getSelectedData !== undefined &&
    //   typeof props.getSelectedData === "function"
    // ) {
    //   props.getSelectedData(row.original);
    // }
    // setRowSelectionState(newState);
    // setSelectedData(newSelectedData);
  }

  function allCheckboxChange(event) {
    if (selectionDisabled === false) {
      updateDataOnAllCheckboxTriggered(event.target.checked, tableData);
    } else {
      const availableData = tableData.filter(
        (d) => d[selectionDisabled] === "false"
      );
      var selectAll =
        availableData.length !== 0 &&
        availableData.length === selectedData.length
          ? false
          : true;
      updateDataOnAllCheckboxTriggered(selectAll, availableData);
    }
  }

  function updateDataOnAllCheckboxTriggered(checked, availableData) {
    var newState = {};
    var newSelectedData = [];
    if (checked) {
      const keys = availableData.map((d) => d.key);
      keys.forEach((k) => {
        newState = { ...newState, [k]: true };
        newSelectedData.push(k);
      });
      if (
        props.getSelectedData !== undefined &&
        typeof props.getSelectedData === "function"
      ) {
        props.getSelectedData(availableData);
      }
    } else {
      if (
        props.getSelectedData !== undefined &&
        typeof props.getSelectedData === "function"
      ) {
        props.getSelectedData({});
      }
    }
    setRowSelectionState(newState);
    setSelectedData(newSelectedData);
  }

  const fullTableSetup = (
    <>
      {/* <MaterialReactTable
        columns={columns}
        data={tableData}
        enableRowSelection
        getRowId={(row) => row.key}
        onRowSelectionChange={setRowSelection}
        state={{ rowSelection }}
      /> */}
      <MaterialReactTable
        // tableInstanceRef={tableRef}
        enableTopToolbar={enableTopToolbar}
        enableStickyHeader={enableStickyHeader}
        enableFullScreenToggle={false}
        enableDensityToggle={false}
        enableHiding={false}
        positionToolbarAlertBanner={"none"}
        // muiTableTopToolbarProps={{ variant: "dense", style: { zIndex: "0" } }}
        muiTopToolbarProps={{ variant: "dense", style: { zIndex: "0" } }}
        enableBottomToolbar={tableData.length > 5 ? true : false}
        muiTableBottomToolbarProps={{ style: { minHeight: 40 } }}
        // muiBottomToolbarProps={{ style: { minHeight: 40} }}
        muiTableHeadCellProps={{
          style: { zIndex: "0" },
        }}
        muiTableHeadProps={{style: { zIndex: "" },}}
        muiTableBodyCellProps={({ cell }) => ({
          children: renderData(cell),
        })}
        enableColumnActions={false}
        enableColumnFilters={enableColumnFilters}
        getRowId={(row) => row.key}
        enableRowNumbers={enableRowNumbers}
        rowNumberMode="static"
        enableRowSelection={enableRowSelection}
        selectAllMode={"all"}
        // onSelectionChange={setRowSelection}
        onRowSelectionChange={setRowSelection}
        muiSelectCheckboxProps={({ row }) => ({
          // onChange: (event) => {
          //   checkboxChange(row, event);
          // },
          disabled:
            selectionDisabled === false
              ? false
              : row.getValue(`${selectionDisabled}`) === "true",
        })}
        // muiSelectAllCheckboxProps={() => ({
        //   onChange: (event) => {
        //     allCheckboxChange(event);
        //   },
        // })}
        // muiTableContainerProps={{ sx: { maxHeight: height, maxWidth: width } }}
        muiTableContainerProps={{ sx: { maxHeight: height, maxWidth: width } }}
        initialState={{ density: "compact" }}
        state={{ rowSelection: rowSelection, columnVisibility:props.invisibleCol, }}
        // onRowSelectionChange={
        //   ({ row }) =>
        //     // onChange: (event) => {
        //     checkboxChange(row)
        //   // },
        // }
        columns={columns}
        data={tableData}
      />
    </>
  );

  if (tableData === undefined || Object.keys(tableData).length === 0) {
    return (
      <>
        <div className={CssClass.noRows}> There are no data to be shown.</div>
      </>
    );
  } else {
    return <>{fullTableSetup}</>;
  }
};

export default Table;
